import { render, staticRenderFns } from "./AddResource.vue?vue&type=template&id=824c77b0"
import script from "./AddResource.vue?vue&type=script&lang=ts"
export * from "./AddResource.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports